/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Accessory } from '../models/Accessory';
import type { AddAccessoryItemToCartRequestV1 } from '../models/AddAccessoryItemToCartRequestV1';
import type { AddArtworkToUserCustomCollectionRequest } from '../models/AddArtworkToUserCustomCollectionRequest';
import type { AddArtworkToUserCustomCollectionResult } from '../models/AddArtworkToUserCustomCollectionResult';
import type { AddSingleItemToCartRequest } from '../models/AddSingleItemToCartRequest';
import type { AddSingleItemToCartRequestV2 } from '../models/AddSingleItemToCartRequestV2';
import type { AddSingleItemToCartV3Response } from '../models/AddSingleItemToCartV3Response';
import type { AddSingleItemToWishlist } from '../models/AddSingleItemToWishlist';
import type { AddToCartEvent } from '../models/AddToCartEvent';
import type { AddToWishlistEvent } from '../models/AddToWishlistEvent';
import type { CartAddAccessoryResult } from '../models/CartAddAccessoryResult';
import type { CreateUserCustomCollectionRequest } from '../models/CreateUserCustomCollectionRequest';
import type { CreateUserCustomCollectionResult } from '../models/CreateUserCustomCollectionResult';
import type { DisplatePdpFeeds } from '../models/DisplatePdpFeeds';
import type { DisplatePdpFeedsV2 } from '../models/DisplatePdpFeedsV2';
import type { DisplatePdpUserV1 } from '../models/DisplatePdpUserV1';
import type { DisplateUserCustomCollection } from '../models/DisplateUserCustomCollection';
import type { Follow } from '../models/Follow';
import type { HeaderContent } from '../models/HeaderContent';
import type { HomepageFeeds } from '../models/HomepageFeeds';
import type { HomepageFeedsV2 } from '../models/HomepageFeedsV2';
import type { Keyword } from '../models/Keyword';
import type { LuminoUserListingV3 } from '../models/LuminoUserListingV3';
import type { LuminoUserV3 } from '../models/LuminoUserV3';
import type { MerchantId } from '../models/MerchantId';
import type { NewsletterSubscribeRequest } from '../models/NewsletterSubscribeRequest';
import type { NewsletterSubscribeResult } from '../models/NewsletterSubscribeResult';
import type { Notify } from '../models/Notify';
import type { PagedResponse_FollowedArtwork_ } from '../models/PagedResponse_FollowedArtwork_';
import type { PagedResponse_FollowedArtworkV2_ } from '../models/PagedResponse_FollowedArtworkV2_';
import type { PagedWishlistItems } from '../models/PagedWishlistItems';
import type { ProductViewedEvent } from '../models/ProductViewedEvent';
import type { ShareAndEarnCode } from '../models/ShareAndEarnCode';
import type { SubscribedEvents } from '../models/SubscribedEvents';
import type { UserInfo } from '../models/UserInfo';
import type { UserInfoV2 } from '../models/UserInfoV2';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BfwUserContextService {
  /**
   * Gets all accessories list with availability info
   * Endpoint that returns list of accessories with sku and isAvailable flag
   *
   * @returns Accessory List of accessories with sku and isAvailable flag.
   * @throws ApiError
   */
  public static getAccessories(): CancelablePromise<Array<Accessory>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/accessories',
    });
  }

  /**
   * Gets all accessories list with availability info without those already in cart
   * Endpoint that returns list of accessories with sku and isAvailable flag
   *
   * @returns Accessory List of accessories with sku and isAvailable flag without these already in cart.
   * @throws ApiError
   */
  public static getAccessoriesCartItemsExcluded(): CancelablePromise<Array<Accessory>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/accessories/cart-items/excluded',
    });
  }

  /**
   * Gets artist code that is used by share and earn module
   * Endpoint that gets artist code that is used by share and earn module
   *
   * @returns ShareAndEarnCode Artist code
   * @throws ApiError
   */
  public static getShareAndEarnCode(): CancelablePromise<ShareAndEarnCode> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/artist/share-and-earn/code',
    });
  }

  /**
   * Adds a single artwork to cart
   * Adds artwork to cart with specified formatId and variant.
   * @param requestBody
   * @returns any Item added successfully
   * @throws ApiError
   */
  public static cartAddSingleItem(requestBody: AddSingleItemToCartRequest): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/elysium-api/user/v1/cart',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid parameters`,
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * Adds an accessory items to cart
   * Adds an accessory items to cart
   * @param requestBody
   * @returns CartAddAccessoryResult Item added successfully
   * @throws ApiError
   */
  public static addAccessoryItem(
    requestBody: AddAccessoryItemToCartRequestV1,
  ): CancelablePromise<CartAddAccessoryResult> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/elysium-api/user/v1/cart/accessory',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid parameters`,
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * getUserCustomCollections
   * Returns list of user custom collections that can be used to store pdp artworks.
   *
   * @returns DisplateUserCustomCollection List of user custom collections
   * @throws ApiError
   */
  public static getUserCustomCollections(): CancelablePromise<Array<DisplateUserCustomCollection>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/custom/collections',
    });
  }

  /**
   * createUserCustomCollection
   * Create new custom collection for user on pdp
   *
   * @param requestBody Payload for adding users custom collection
   * @returns CreateUserCustomCollectionResult info with id of collection
   * @throws ApiError
   */
  public static createUserCustomCollection(
    requestBody: CreateUserCustomCollectionRequest,
  ): CancelablePromise<CreateUserCustomCollectionResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/elysium-api/user/v1/custom/collections',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        409: `Collection already exist`,
      },
    });
  }

  /**
   * addArtworkToUserCustomCollection
   * Create new custom collection for user on pdp
   *
   * @param collectionId
   * @param requestBody Payload for adding item do user custom collection
   * @returns AddArtworkToUserCustomCollectionResult info with id of collection
   * @throws ApiError
   */
  public static addArtworkToUserCustomCollection(
    collectionId: number,
    requestBody: AddArtworkToUserCustomCollectionRequest,
  ): CancelablePromise<AddArtworkToUserCustomCollectionResult> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/elysium-api/user/v1/custom/collections/{collectionId}',
      path: {
        collectionId: collectionId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        409: `Item is already added to collection`,
      },
    });
  }

  /**
   * Gets displate pdp user-context data
   * Returns user-context data for user on displate pdp page, including: delivery time and price variants
   *
   * @param externalId
   * @returns DisplatePdpUserV1 Gets displate pdp user-context data
   * @throws ApiError
   */
  public static getDisplatePdpUserDataV1(externalId: number): CancelablePromise<DisplatePdpUserV1> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/displate-pdp/{externalId}',
      path: {
        externalId: externalId,
      },
    });
  }

  /**
   * @deprecated
   * getDisplatePdpExperimentalFeeds
   * Returns similar, popular and bestselling for the provided id. This endpoint requires athena user id because of how the internal service works.
   * This endpoint is for ab-test, so we also require `type` query parameter (information about type of experiment)
   *
   * @param internalId Internal id of the product
   * @param au Athena user id. Can be taken from _ath_usr cookie
   * @param et Experiment type.
   * @param categoryId artwork category id
   * @returns DisplatePdpFeeds Feeds with lists of artworks
   * @throws ApiError
   */
  public static getDisplatePdpExperimentalFeeds(
    internalId: number,
    au: string,
    et: string,
    categoryId?: number | null,
  ): CancelablePromise<DisplatePdpFeeds> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/displate-pdp/{internalId}/experimental/feed',
      path: {
        internalId: internalId,
      },
      query: {
        au: au,
        et: et,
        categoryId: categoryId,
      },
    });
  }

  /**
   * @deprecated
   * getDisplatePdpFeeds
   * Returns similar, popular and bestselling for the provided id. This endpoint requires athena user id because of how the internal service works.
   *
   * @param internalId Internal id of the product
   * @param au Athena user id. Can be taken from _ath_usr cookie
   * @param categoryId artwork category id
   * @returns DisplatePdpFeeds Feeds with lists of artworks
   * @throws ApiError
   */
  public static getDisplatePdpFeeds(
    internalId: number,
    au: string,
    categoryId?: number | null,
  ): CancelablePromise<DisplatePdpFeeds> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/displate-pdp/{internalId}/feed',
      path: {
        internalId: internalId,
      },
      query: {
        au: au,
        categoryId: categoryId,
      },
    });
  }

  /**
   * Gets followed by user authors ids
   * Endpoint that returns followed authors ids for currently logged user
   *
   * @returns number Authors of followed authors
   * @throws ApiError
   */
  public static getFollowedAuthors(): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/followed-authors',
    });
  }

  /**
   * @deprecated
   * Gets followed by user artworks list
   * Endpoint that returns followed artworks feed for currently logged user
   *
   * @param offset Offset value for paging
   * @param limit Limit value for paging
   * @returns PagedResponse_FollowedArtwork_ Artworks of followed authors
   * @throws ApiError
   */
  public static getFollowedArtworks(
    offset?: number | null,
    limit: number | null = 54,
  ): CancelablePromise<PagedResponse_FollowedArtwork_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/follows',
      query: {
        offset: offset,
        limit: limit,
      },
    });
  }

  /**
   * Follow specific author
   * Endpoint for user to follow specific author, can return redirection url if user is guest
   *
   * @param authorId
   * @returns Follow
   * @throws ApiError
   */
  public static followAuthor(authorId: number): CancelablePromise<Follow> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/elysium-api/user/v1/follows/{authorId}',
      path: {
        authorId: authorId,
      },
    });
  }

  /**
   * Unfollow specific author
   * Endpoint for user to unfollow specific author, if user is guest does nothing
   *
   * @param authorId
   * @returns boolean
   * @throws ApiError
   */
  public static unfollowAuthor(authorId: number): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/elysium-api/user/v1/follows/{authorId}',
      path: {
        authorId: authorId,
      },
    });
  }

  /**
   * Gets user's customised header data
   * Allows to get user specific data for header user specific items (cart and wishlist count, etc)
   * @returns HeaderContent Header specific content
   * @throws ApiError
   */
  public static getHeaderContent(): CancelablePromise<HeaderContent> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/header-content',
      errors: {
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * getHomepageFeeds
   * Returns gallery data with feeds list for homepage
   *
   * @param au Athena user id. Can be taken from _ath_usr cookie
   * @returns HomepageFeeds Returns trending, following and bestselling. This endpoint requires athena user id because of how the internal service works.
   * @throws ApiError
   */
  public static getHomepageFeeds(au: string): CancelablePromise<HomepageFeeds> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/homepage/feed',
      query: {
        au: au,
      },
    });
  }

  /**
   * @deprecated
   * Gets userInfo
   * Allows to get user info by cookie
   * @returns UserInfo User info
   * @throws ApiError
   */
  public static getUserInfo(): CancelablePromise<UserInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/info',
      errors: {
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * Gets user's keywords
   * Allows to get user specific keywords
   * @returns Keyword Header specific content
   * @throws ApiError
   */
  public static getKeywords(): CancelablePromise<Array<Keyword>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/keywords',
      errors: {
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * Sets user's keywords
   * Allows to set user specific keywords
   * @param requestBody
   * @returns any Header specific content
   * @throws ApiError
   */
  public static setKeywords(requestBody: { keywords?: Array<Keyword> }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/elysium-api/user/v1/keywords',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Elysium cookie in request but user not logged in`,
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * Gets merchantId
   * Returns a secured merchantId cookie and response
   * @param art
   * @returns MerchantId MerchantId returned in Json response and as a cookie
   * @throws ApiError
   */
  public static getMerchantId(art: string): CancelablePromise<MerchantId> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/merchant-id/{art}',
      path: {
        art: art,
      },
    });
  }

  /**
   * Subscribes to newsletter
   * Adds email to internal email list to be synchronized with marketing tool later
   * @param requestBody
   * @returns NewsletterSubscribeResult Operation result
   * @throws ApiError
   */
  public static newsletterSubscribe(
    requestBody: NewsletterSubscribeRequest,
  ): CancelablePromise<NewsletterSubscribeResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/elysium-api/user/v1/newsletter',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `No elysium cookie in request or invalid email format`,
      },
    });
  }

  /**
   * @deprecated
   * Gets events subscribed by user
   * Endpoint that returns subscribed events ids for currently logged user
   *
   * @returns string List of subscribed events ids.
   * @throws ApiError
   */
  public static getSubscribedEvents(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/notify',
    });
  }

  /**
   * Subscribe to event
   * Endpoint for user to subscribe specific event, can return if subscription is first ever or not
   *
   * @param eventId
   * @returns Notify Returns if subscription is first or not.
   * @throws ApiError
   */
  public static subscribeToEvent(eventId: string): CancelablePromise<Notify> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/elysium-api/user/v1/notify/{eventId}',
      path: {
        eventId: eventId,
      },
    });
  }

  /**
   * Unsubscribe specific event
   * Endpoint for user to unsubscribe specific event
   *
   * @param eventId
   * @returns boolean Returns if event has been unsubscribed.
   * @throws ApiError
   */
  public static unsubscribeFromEvent(eventId: string): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/elysium-api/user/v1/notify/{eventId}',
      path: {
        eventId: eventId,
      },
    });
  }

  /**
   * @param externalId External id of the product
   * @param fbp https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
   * @param fbc https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
   * @returns ProductViewedEvent Content for fb pixel event
   * @throws ApiError
   */
  public static createProductViewedEvent(
    externalId: number,
    fbp?: string | null,
    fbc?: string | null,
  ): CancelablePromise<ProductViewedEvent> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/elysium-api/user/v1/pixel/conversion/product/{externalId}/viewed',
      path: {
        externalId: externalId,
      },
      cookies: {
        _fbp: fbp,
        _fbc: fbc,
      },
    });
  }

  /**
   * getSession
   * Creates new session if no session is found
   * @param ctrc
   * @returns string Simple HTML page that informs iframe parent that session is loaded. Response also contains session cookies
   * @throws ApiError
   */
  public static getSession(ctrc?: string | null): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/session',
      query: {
        ctrc: ctrc,
      },
    });
  }

  /**
   * @deprecated
   * A list of wishlist items
   * Returns a paged list of users wishlist, THIS IS TEMP, TO BE CHANGED WHEN GOING TO PROD
   * @param offset
   * @param limit
   * @returns PagedWishlistItems Item list
   * @throws ApiError
   */
  public static getWishlistItems(
    offset: number,
    limit: number,
  ): CancelablePromise<PagedWishlistItems> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v1/wishlist',
      query: {
        offset: offset,
        limit: limit,
      },
      errors: {
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * Adds to wishlist
   * Adds a single item to users wishlist
   * @param requestBody
   * @param fbp https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
   * @param fbc https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
   * @returns AddToWishlistEvent Item added successfully
   * @throws ApiError
   */
  public static wishlistAddSingleItem(
    requestBody: AddSingleItemToWishlist,
    fbp?: string | null,
    fbc?: string | null,
  ): CancelablePromise<AddToWishlistEvent> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/elysium-api/user/v1/wishlist',
      cookies: {
        _fbp: fbp,
        _fbc: fbc,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Item not added to wishlist`,
        401: `No elysium cookie in request`,
        419: `Session has expired`,
      },
    });
  }

  /**
   * Removes from wishlist
   * Removes a single item from users wishlist
   * @param itemCollectionId
   * @returns any Item removed successfully
   * @throws ApiError
   */
  public static wishlistRemoveSingleItem(itemCollectionId: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/elysium-api/user/v1/wishlist/{itemCollectionId}',
      path: {
        itemCollectionId: itemCollectionId,
      },
      errors: {
        400: `Item not found in wishlist`,
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * Adds a single artwork to cart
   * Adds artwork to cart with specified formatId and variant.
   * @param requestBody
   * @param fbp https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
   * @param fbc https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
   * @returns AddToCartEvent Item added successfully
   * @throws ApiError
   */
  public static cartAddSingleItemV2(
    requestBody: AddSingleItemToCartRequestV2,
    fbp?: string | null,
    fbc?: string | null,
  ): CancelablePromise<AddToCartEvent> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/elysium-api/user/v2/cart',
      cookies: {
        _fbp: fbp,
        _fbc: fbc,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid parameters`,
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * getDisplatePdpExperimentalFeedsV2
   * Returns similar, popular and bestselling for the provided id. This endpoint requires athena user id because of how the internal service works.
   * This endpoint is for ab-test, so we also require `type` query parameter (information about type of experiment)
   *
   * @param internalId Internal id of the product
   * @param au Athena user id. Can be taken from _ath_usr cookie
   * @param et Experiment type.
   * @param categoryId artwork category id
   * @returns DisplatePdpFeedsV2 Feeds with lists of artworks
   * @throws ApiError
   */
  public static getDisplatePdpExperimentalFeedsV2(
    internalId: number,
    au: string,
    et: string,
    categoryId?: number | null,
  ): CancelablePromise<DisplatePdpFeedsV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v2/displate-pdp/{internalId}/experimental/feed',
      path: {
        internalId: internalId,
      },
      query: {
        au: au,
        et: et,
        categoryId: categoryId,
      },
    });
  }

  /**
   * getDisplatePdpFeedsV2
   * Returns similar, popular and bestselling for the provided id. This endpoint requires athena user id because of how the internal service works.
   *
   * @param internalId Internal id of the product
   * @param au Athena user id. Can be taken from _ath_usr cookie
   * @param categoryId artwork category id
   * @returns DisplatePdpFeedsV2 Feeds with lists of artworks
   * @throws ApiError
   */
  public static getDisplatePdpFeedsV2(
    internalId: number,
    au: string,
    categoryId?: number | null,
  ): CancelablePromise<DisplatePdpFeedsV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v2/displate-pdp/{internalId}/feed',
      path: {
        internalId: internalId,
      },
      query: {
        au: au,
        categoryId: categoryId,
      },
    });
  }

  /**
   * Gets followed by user artworks list
   * Endpoint that returns followed artworks feed for currently logged user
   *
   * @param offset Offset value for paging
   * @param limit Limit value for paging
   * @returns PagedResponse_FollowedArtworkV2_ Artworks of followed authors
   * @throws ApiError
   */
  public static getFollowedArtworksV2(
    offset?: number | null,
    limit: number | null = 54,
  ): CancelablePromise<PagedResponse_FollowedArtworkV2_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v2/follows',
      query: {
        offset: offset,
        limit: limit,
      },
    });
  }

  /**
   * getHomepageFeeds
   * Returns gallery data with feeds list for homepage
   *
   * @param au Athena user id. Can be taken from _ath_usr cookie
   * @returns HomepageFeedsV2 Returns trending, following and bestselling. This endpoint requires athena user id because of how the internal service works.
   * @throws ApiError
   */
  public static getHomepageFeedsV2(au: string): CancelablePromise<HomepageFeedsV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v2/homepage/feed',
      query: {
        au: au,
      },
    });
  }

  /**
   * Gets userInfo
   * Allows to get user info by cookie
   * @returns UserInfoV2 User info
   * @throws ApiError
   */
  public static getUserInfoV2(): CancelablePromise<UserInfoV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v2/info',
      errors: {
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * Gets events subscribed by user
   * Endpoint that returns subscribed events ids for currently logged user
   *
   * @returns SubscribedEvents List of subscribed events ids.
   * @throws ApiError
   */
  public static getSubscribedEvents1(): CancelablePromise<SubscribedEvents> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v2/notify',
    });
  }

  /**
   * Adds a single artwork to cart
   * Adds artwork to cart with specified formatId and variant.
   * @param requestBody
   * @param fbp https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
   * @param fbc https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
   * @returns AddSingleItemToCartV3Response Item added successfully
   * @throws ApiError
   */
  public static cartAddSingleItemV3(
    requestBody: AddSingleItemToCartRequestV2,
    fbp?: string | null,
    fbc?: string | null,
  ): CancelablePromise<AddSingleItemToCartV3Response> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/elysium-api/user/v3/cart',
      cookies: {
        _fbp: fbp,
        _fbc: fbc,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid parameters`,
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * Gets lumino user-context listing
   * Returns user-context listing for user on lumino page, including: isAvailable
   *
   * @param limit
   * @returns LuminoUserListingV3 Gets lumino user-context listing
   * @throws ApiError
   */
  public static getLuminoUserListing(
    limit?: number | null,
  ): CancelablePromise<LuminoUserListingV3> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v3/lumino/listing',
      query: {
        limit: limit,
      },
    });
  }

  /**
   * Gets lumino user-context data
   * Returns user-context data for user on lumino page, including: delivery time, currency, metric/imperial size
   *
   * @param externalId
   * @returns LuminoUserV3 Gets lumino user-context data
   * @throws ApiError
   */
  public static getLuminoUserDataV3(externalId: number): CancelablePromise<LuminoUserV3> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/user/v3/lumino/{externalId}',
      path: {
        externalId: externalId,
      },
    });
  }
}
